import getPlanTypeKey from 'core/controllerPlans/getPlanTypeKey'

interface AvailableOptions {
  currentPlan: Plan
  currentFilter: string
  filters: string[]
  plansSTM: number[]
  plans: { [key: number]: Plan }
}

function getAvailableOptions({
  currentPlan,
  currentFilter,
  filters,
  plansSTM,
  plans
}: AvailableOptions) {
  const currentPlanTypeKey = getPlanTypeKey(currentPlan)
  const availableOptions = plansSTM
    .filter(planId => currentPlanTypeKey === getPlanTypeKey(plans[planId]))
    .filter(planId =>
      filters.reduce(
        (accum, currentValue) =>
          accum &&
          plans[planId].coreBenefits[currentValue] ===
            currentPlan.coreBenefits[currentValue],
        true
      )
    )
    .reduce((result, planId) => {
      return [...result, plans[planId].coreBenefits[currentFilter]]
    }, [])

  return availableOptions
}

export default getAvailableOptions
